var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('controllable-drawer-bottom',{attrs:{"title":"权益说明","show":(_vm.show),"headerStyle":(_vm.headerStyle),"iconStyle":(_vm.iconStyle)},on:{"close":_vm.closeDrawer}},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"description"},[_vm._v(_vm._s(_vm.descriptionContent))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }